import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { GET_QUIZZES, REMOVE_QUIZ } from '../../apollo/quizzes.ts';

export const useQuizzesFilter = () => {
  const [filter, setFilter] = useState<{
    name?: string;
    description?: string;
  }>({
    name: undefined,
    description: undefined,
  });
  const onChangeFilter = useCallback((value?: string, type?: string) => {
    setFilter((prev) => {
      const next = {
        name: type === 'name' ? value : undefined,
        description: type === 'description' ? value : undefined,
      };

      if (
        prev.name === next.name &&
        prev.description === next.description
      ) {
        return prev;
      }

      return next;
    });
  }, []);

  return { filter, onChangeFilter };
};

export const useRemoveQuizzes = (afterRemove?: () => void) => {
  const [removeModal, setRemoveModal] = useState(false);
  const onCloseRemove = () => setRemoveModal(false);
  const onOpenRemove = () => setRemoveModal(true);
  const [remove] = useMutation(REMOVE_QUIZ, {
    refetchQueries: [{ query: GET_QUIZZES }],
  });
  const onRemoveQuizzes = (ids: number[]) => {
    if (!ids.length) return null;

    afterRemove?.();

    return remove({
      awaitRefetchQueries: true,
      refetchQueries: [{ query: GET_QUIZZES }],
      variables: {
        input: {
          ids,
        },
      },
    });
  };

  return { onRemoveQuizzes, onOpenRemove, onCloseRemove, removeModal };
};
